import React from 'react';
import { motion } from 'framer-motion';
import './RACExitPolicy.css';

const RACExitPolicy = () => {
  console.log('[RACExitPolicy] Component rendered');
  
  return (
    <section className="rac-exit-policy">
      <div className="rac-exit-policy-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rac-exit-policy-content"
        >
          <h2 className="rac-section-title">Exit Policy</h2>
          <div className="rac-gold-line"></div>
          <div className="rac-exit-policy-text">
            <p className="rac-exit-intro">
              After the lock-in, PharmWealth offers buyback at full contract value (as defined in the hire-back agreement), subject to hire-back agreement conditions and completion of documentation/transfer steps. Settlement timelines are defined in the hire-back agreement. Buyback requires completion of documentation and transfer/novation steps defined in the hire-back agreement; outstanding dues/adjustments (if any) may be netted off.
            </p>
            <div className="rac-exit-details">
              <p><strong>Lock-in period:</strong> 2 years</p>
              <p><strong>Buyback available:</strong> Only after the 2-year lock-in</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default RACExitPolicy;


